import React from "react";
import { Dialog, Flex, Text, TextField, Button } from "@radix-ui/themes";

export function AuthBloomreachDialog({
  isOpen,
  onOpenChange,
  onCancel,
  onSave,
  values,
  onChange,
  fieldErrors,
  isLoading,
}) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content maxWidth="640px">
        <Dialog.Title>Connect Bloomreach</Dialog.Title>
        <Dialog.Description size="2" mb="4">
          Use a private API group from Bloomreach Engagement: Project settings → Access
          management → API. Paste the project token, API Key ID, and API Secret. Base URL
          defaults to https://api.exponea.com unless your instance uses a custom host.
        </Dialog.Description>

        <Flex direction="column" gap="3">
          <Flex direction="column" gap="1">
            <Text size="2" weight="medium">API base URL</Text>
            <TextField.Root
              value={values.api_base_url}
              onChange={(e) => onChange("api_base_url", e.target.value)}
              placeholder="https://api.exponea.com"
            />
          </Flex>
          <Flex direction="column" gap="1">
            <Text size="2" weight="medium">Project token</Text>
            <TextField.Root
              value={values.project_token}
              onChange={(e) => onChange("project_token", e.target.value)}
              placeholder="Project token"
            />
            {fieldErrors.project_token && (
              <Text size="1" color="red">Project token is required.</Text>
            )}
          </Flex>
          <Flex direction="column" gap="1">
            <Text size="2" weight="medium">API Key ID</Text>
            <TextField.Root
              value={values.api_key_id}
              onChange={(e) => onChange("api_key_id", e.target.value)}
              placeholder="Private API Key ID"
            />
            {fieldErrors.api_key_id && (
              <Text size="1" color="red">API Key ID is required.</Text>
            )}
          </Flex>
          <Flex direction="column" gap="1">
            <Text size="2" weight="medium">API Secret</Text>
            <TextField.Root
              type="password"
              value={values.api_secret}
              onChange={(e) => onChange("api_secret", e.target.value)}
              placeholder="Private API Secret"
            />
            {fieldErrors.api_secret && (
              <Text size="1" color="red">API Secret is required.</Text>
            )}
          </Flex>
        </Flex>

        <Flex justify="end" gap="3" mt="4">
          <Dialog.Close>
            <Button onClick={onCancel} variant="soft" color="gray">
              Cancel
            </Button>
          </Dialog.Close>
          <Button onClick={() => onSave()} loading={isLoading} variant="soft" color="accent">
            Continue
          </Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
